export const APP_NAME = "Ron Gorai's NPM Platform"
